/**
 * 左侧目录
 */
export default {
  dbl_virtual_table_source_name: '名称',
  dbl_virtual_table_source_name_placeholder: '请输入数据源名称',
  dbl_virtual_table_label: '标签',
  dbl_virtual_table_label_placeholder: '请选择标签',
  dbl_virtual_table_cycle: '更新周期',
  dbl_virtual_table_cycle_placeholder: '请选择更新周期',
  dbl_virtual_table_desc: '描述',
  dbl_virtual_table_desc_placeholder: '请输入数据源描述',
  dbl_virtual_table_task_custom: '自定义标签',
  dbl_virtual_table_task_custom_cycle: '自定义标签',
  dbl_virtual_table_task_custom_placeholder: '请输入新标签的名称',
  dbl_virtual_table_task_label_same: "目录下已有相同标签，请重新命名",

  dbl_virtual_table_source_name_repeat: '同一游戏和用户（创建者）下不允许使用重复的名称。',
  dbl_virtual_table_source_name_valid: '以字母或下划线开头，支持字母、数字和下划线，特殊字符必须使用引号或转义符号。',
  dbl_virtual_table_source_name_length_limit: '长度限制200字符。',
  dbl_virtual_table_save_type: '保存类型',
  dbl_virtual_table_save_as: '另存为',
  dbl_virtual_table_update: '覆盖',
  dbl_virtual_table_update_warning: '请注意：修改这些设置将影响所有使用该数据源的图表（包括其他用户创建的图表）。',

  dbl_virtual_table_fail: 'SQL保存失败。',
  dbl_virtual_table_success: 'SQL保存成功。',
  dbl_virtual_table_update_fail: '更新失败。',
  dbl_virtual_table_save_fail: '保存失败。',
  dbl_virtual_table_update_success: '更新成功',
  dbl_virtual_table_save_success: '保存成功',
};